var auth = require('./tripletrax.auth.js');
var validator = require('./tripletrax.validator.js');
var datatable = require('./tripletrax.datatable.js');
var events = require('./tripletrax.events.js');
var views = require('./tripletrax.views.js');
var reports = require('./tripletrax.reports.js');
var monitoring = require('./tripletrax.monitoring.js');
var mails = require('./tripletrax.mails.js');
var devices = require('./tripletrax.devices.js');
var pushman = require('./tripletrax.pushman.js');
var integrities = require('./tripletrax.integrities.js');
var stats = require('./tripletrax.stats.js');

// Event classAdded auslösen, wenn eine Klasse hinzugefügt wird
var originalAddClassMethod = jQuery.fn.addClass;
jQuery.fn.addClass = function() {

    var result = originalAddClassMethod.apply(this, arguments);
    jQuery(this).trigger('classAdded');

    return result;
};
$.fn.modal.Constructor.prototype.enforceFocus = function() {};

auth.registerAuthEvents();
events.registerCommonEvents();
events.registerNestableEvents();
events.registerDocumentationEvents();
integrities.registerIntegritiesEvents();
views.registerViewEvents();
reports.registerReportsEvents();
monitoring.registerMonitoringEvents();
mails.registerMailsEvents();
devices.registerDevicesEvents();
validator.validatorMethods();
datatable.dataTableMethods();
pushman.registerPushmanEvents();
stats.registerStatsEvents();
